var moment = require('moment');

function Module() {
	'use strict';

	var self = this;

	self.apply = function apply(app) {
		app.directive('spinnerLoad', [function spinnerLoad() {
			return {
				restrict: 'A',
				link: function spinnerLoadLink(scope, elem, attrs) {
					scope.$watch('ngSrc', function watchNgSrc() {
						elem.hide();
						elem.after('<i class="fa fa-spinner fa-lg fa-spin"></i>');	// add spinner
					});
					elem.on('load', function onLoad() {
						elem.show();
						elem.next('i.fa-spinner').remove();	// remove spinner
					});
				}
			};
		}]);
	};
}

module.exports = new Module();
